import React, { useState, useEffect } from "react";
import {
    TextField,
    Button,
    Grid,
    Typography,
    InputLabel,
    Box,
    Select, MenuItem, FormHelperText, FormControl
} from "@mui/material";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import GoogleCaptchaV3 from "./components/googleCaptchaV3";
import Header from './components/header';
import Footer from './components/footer';
import { PostDataAPI } from './services/PostDataAPI';
import { Helper } from './common/Helpers';
import { withSnackbar } from "./common/Alert";
import { Modal } from '@mui/base/Modal';
import SuccessErrorDialog from "./components/successErrorDialog";
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SEOTags from './common/SEO';


const MeetingRequestForm = (props) => {
    const { showMessage } = props;
    const [refreshCaptcha, setRefreshCaptcha] = useState(false);
    const [formValues, setFormValues] = useState({
        name: "",
        phone: "",
        email: "",
        requestReason: "",
        meetingDate: null,
        addressLine1: "",
        addressLine2: "",
        city: "",
        state: "",
        postalCode: "",
        country: "",
        message: "",
    });

    const initialFormValues = {
        name: "",
        phone: "",
        email: "",
        requestReason: "",
        meetingDate: null,
        addressLine1: "",
        addressLine2: "",
        city: "",
        state: "",
        postalCode: "",
        country: "",
        message: "",
    };

    const handleReset = () => {
        setFormValues(initialFormValues);
    }

    const [googleCaptchaToken, setGoogleCaptchaToken] = useState("");
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});

    const [resultDialog, setResultDialog] = useState(false);

    //const { executeRecaptcha } = useGoogleReCaptcha();
    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "phone") {
            const phoneValue = value
                .replace(/\D/g, "") // Remove non-numeric characters
                .replace(/(\d{3})(\d{3})(\d{1,4})/, "($1) $2-$3") // Apply mask
                .slice(0, 14); // Limit length
            setFormValues((prevData) => ({ ...prevData, [name]: phoneValue }));
        } else {
            setFormValues((prev) => ({ ...prev, [name]: value }));
        }

    };


    const handleDateChange = (date) => {
        setFormValues((prev) => ({ ...prev, meetingDate: date }));
    };

    const meetingReasonOptions = [
        { value: 'Idea Sharing Meeting', label: 'Idea Sharing Meeting' },
        { value: 'New Product Launching', label: 'New Product Launching' },
        { value: 'News Interviews', label: 'News Interviews' },
        { value: 'Charity Event', label: 'Charity Event' },
    ];

    const countriesOptions = [
        { value: '', label: 'Select Country' },
        { value: 'AF', label: 'Afghanistan' },
        { value: 'AX', label: 'Aland Islands' },
        { value: 'AL', label: 'Albania' },
        { value: 'DZ', label: 'Algeria' },
        { value: 'AS', label: 'American Samoa' },
        { value: 'AD', label: 'Andorra' },
        { value: 'AO', label: 'Angola' },
        { value: 'AI', label: 'Anguilla' },
        { value: 'AQ', label: 'Antarctica' },
        { value: 'AG', label: 'Antigua and Barbuda' },
        { value: 'AR', label: 'Argentina' },
        { value: 'AM', label: 'Armenia' },
        { value: 'AW', label: 'Aruba' },
        { value: 'AU', label: 'Australia' },
        { value: 'AT', label: 'Austria' },
        { value: 'AZ', label: 'Azerbaijan' },
        { value: 'BS', label: 'Bahamas' },
        { value: 'BH', label: 'Bahrain' },
        { value: 'BD', label: 'Bangladesh' },
        { value: 'BB', label: 'Barbados' },
        { value: 'BY', label: 'Belarus' },
        { value: 'PW', label: 'Belau' },
        { value: 'BE', label: 'Belgium' },
        { value: 'BZ', label: 'Belize' },
        { value: 'BJ', label: 'Benin' },
        { value: 'BM', label: 'Bermuda' },
        { value: 'BT', label: 'Bhutan' },
        { value: 'BO', label: 'Bolivia' },
        { value: 'BQ', label: 'Bonaire, Saint Eustatius and Saba' },
        { value: 'BA', label: 'Bosnia and Herzegovina' },
        { value: 'BW', label: 'Botswana' },
        { value: 'BV', label: 'Bouvet Island' },
        { value: 'BR', label: 'Brazil' },
        { value: 'IO', label: 'British Indian Ocean Territory' },
        { value: 'VG', label: 'British Virgin Islands' },
        { value: 'BN', label: 'Brunei' },
        { value: 'BG', label: 'Bulgaria' },
        { value: 'BF', label: 'Burkina Faso' },
        { value: 'BI', label: 'Burundi' },
        { value: 'KH', label: 'Cambodia' },
        { value: 'CM', label: 'Cameroon' },
        { value: 'CA', label: 'Canada' },
        { value: 'CV', label: 'Cape Verde' },
        { value: 'KY', label: 'Cayman Islands' },
        { value: 'CF', label: 'Central African Republic' },
        { value: 'TD', label: 'Chad' },
        { value: 'CL', label: 'Chile' },
        { value: 'CN', label: 'China' },
        { value: 'CX', label: 'Christmas Island' },
        { value: 'CC', label: 'Cocos (Keeling) Islands' },
        { value: 'CO', label: 'Colombia' },
        { value: 'KM', label: 'Comoros' },
        { value: 'CG', label: 'Congo (Brazzaville)' },
        { value: 'CD', label: 'Congo (Kinshasa)' },
        { value: 'CK', label: 'Cook Islands' },
        { value: 'CR', label: 'Costa Rica' },
        { value: 'HR', label: 'Croatia' },
        { value: 'CU', label: 'Cuba' },
        { value: 'CW', label: 'Cura�ao' },
        { value: 'CY', label: 'Cyprus' },
        { value: 'CZ', label: 'Czech Republic' },
        { value: 'DK', label: 'Denmark' },
        { value: 'DJ', label: 'Djibouti' },
        { value: 'DM', label: 'Dominica' },
        { value: 'DO', label: 'Dominican Republic' },
        { value: 'EC', label: 'Ecuador' },
        { value: 'EG', label: 'Egypt' },
        { value: 'SV', label: 'El Salvador' },
        { value: 'GQ', label: 'Equatorial Guinea' },
        { value: 'ER', label: 'Eritrea' },
        { value: 'EE', label: 'Estonia' },
        { value: 'ET', label: 'Ethiopia' },
        { value: 'FK', label: 'Falkland Islands' },
        { value: 'FO', label: 'Faroe Islands' },
        { value: 'FJ', label: 'Fiji' },
        { value: 'FI', label: 'Finland' },
        { value: 'FR', label: 'France' },
        { value: 'GF', label: 'French Guiana' },
        { value: 'PF', label: 'French Polynesia' },
        { value: 'TF', label: 'French Southern Territories' },
        { value: 'GA', label: 'Gabon' },
        { value: 'GM', label: 'Gambia' },
        { value: 'GE', label: 'Georgia' },
        { value: 'DE', label: 'Germany' },
        { value: 'GH', label: 'Ghana' },
        { value: 'GI', label: 'Gibraltar' },
        { value: 'GR', label: 'Greece' },
        { value: 'GL', label: 'Greenland' },
        { value: 'GD', label: 'Grenada' },
        { value: 'GP', label: 'Guadeloupe' },
        { value: 'GU', label: 'Guam' },
        { value: 'GT', label: 'Guatemala' },
        { value: 'GG', label: 'Guernsey' },
        { value: 'GN', label: 'Guinea' },
        { value: 'GW', label: 'Guinea-Bissau' },
        { value: 'GY', label: 'Guyana' },
        { value: 'HT', label: 'Haiti' },
        { value: 'HM', label: 'Heard Island and McDonald Islands' },
        { value: 'HN', label: 'Honduras' },
        { value: 'HK', label: 'Hong Kong' },
        { value: 'HU', label: 'Hungary' },
        { value: 'IS', label: 'Iceland' },
        { value: 'IN', label: 'India' },
        { value: 'ID', label: 'Indonesia' },
        { value: 'IR', label: 'Iran' },
        { value: 'IQ', label: 'Iraq' },
        { value: 'IE', label: 'Ireland' },
        { value: 'IM', label: 'Isle of Man' },
        { value: 'IL', label: 'Israel' },
        { value: 'IT', label: 'Italy' },
        { value: 'CI', label: 'Ivory Coast' },
        { value: 'JM', label: 'Jamaica' },
        { value: 'JP', label: 'Japan' },
        { value: 'JE', label: 'Jersey' },
        { value: 'JO', label: 'Jordan' },
        { value: 'KZ', label: 'Kazakhstan' },
        { value: 'KE', label: 'Kenya' },
        { value: 'KI', label: 'Kiribati' },
        { value: 'XK', label: 'Kosovo' },
        { value: 'KW', label: 'Kuwait' },
        { value: 'KG', label: 'Kyrgyzstan' },
        { value: 'LA', label: 'Laos' },
        { value: 'LV', label: 'Latvia' },
        { value: 'LB', label: 'Lebanon' },
        { value: 'LS', label: 'Lesotho' },
        { value: 'LR', label: 'Liberia' },
        { value: 'LY', label: 'Libya' },
        { value: 'LI', label: 'Liechtenstein' },
        { value: 'LT', label: 'Lithuania' },
        { value: 'LU', label: 'Luxembourg' },
        { value: 'MO', label: 'Macao S.A.R., China' },
        { value: 'MK', label: 'Macedonia' },
        { value: 'MG', label: 'Madagascar' },
        { value: 'MW', label: 'Malawi' },
        { value: 'MY', label: 'Malaysia' },
        { value: 'MV', label: 'Maldives' },
        { value: 'ML', label: 'Mali' },
        { value: 'MT', label: 'Malta' },
        { value: 'MH', label: 'Marshall Islands' },
        { value: 'MQ', label: 'Martinique' },
        { value: 'MR', label: 'Mauritania' },
        { value: 'MU', label: 'Mauritius' },
        { value: 'YT', label: 'Mayotte' },
        { value: 'MX', label: 'Mexico' },
        { value: 'FM', label: 'Micronesia' },
        { value: 'MD', label: 'Moldova' },
        { value: 'MC', label: 'Monaco' },
        { value: 'MN', label: 'Mongolia' },
        { value: 'ME', label: 'Montenegro' },
        { value: 'MS', label: 'Montserrat' },
        { value: 'MA', label: 'Morocco' },
        { value: 'MZ', label: 'Mozambique' },
        { value: 'MM', label: 'Myanmar' },
        { value: 'NA', label: 'Namibia' },
        { value: 'NR', label: 'Nauru' },
        { value: 'NP', label: 'Nepal' },
        { value: 'NL', label: 'Netherlands' },
        { value: 'NC', label: 'New Caledonia' },
        { value: 'NZ', label: 'New Zealand' },
        { value: 'NI', label: 'Nicaragua' },
        { value: 'NE', label: 'Niger' },
        { value: 'NG', label: 'Nigeria' },
        { value: 'NU', label: 'Niue' },
        { value: 'NF', label: 'Norfolk Island' },
        { value: 'KP', label: 'North Korea' },
        { value: 'MP', label: 'Northern Mariana Islands' },
        { value: 'NO', label: 'Norway' },
        { value: 'OM', label: 'Oman' },
        { value: 'PK', label: 'Pakistan' },
        { value: 'PW', label: 'Palau' },
        { value: 'PS', label: 'Palestinian Territory' },
        { value: 'PA', label: 'Panama' },
        { value: 'PG', label: 'Papua New Guinea' },
        { value: 'PY', label: 'Paraguay' },
        { value: 'PE', label: 'Peru' },
        { value: 'PH', label: 'Philippines' },
        { value: 'PN', label: 'Pitcairn' },
        { value: 'PL', label: 'Poland' },
        { value: 'PT', label: 'Portugal' },
        { value: 'PR', label: 'Puerto Rico' },
        { value: 'QA', label: 'Qatar' },
        { value: 'RE', label: 'Reunion' },
        { value: 'RO', label: 'Romania' },
        { value: 'RU', label: 'Russia' },
        { value: 'RW', label: 'Rwanda' },
        { value: 'BL', label: 'Saint Barth�lemy' },
        { value: 'SH', label: 'Saint Helena' },
        { value: 'KN', label: 'Saint Kitts and Nevis' },
        { value: 'LC', label: 'Saint Lucia' },
        { value: 'MF', label: 'Saint Martin (French part)' },
        { value: 'PM', label: 'Saint Pierre and Miquelon' },
        { value: 'VC', label: 'Saint Vincent and the Grenadines' },
        { value: 'WS', label: 'Samoa' },
        { value: 'SM', label: 'San Marino' },
        { value: 'ST', label: 'Sao Tome and Principe' },
        { value: 'SA', label: 'Saudi Arabia' },
        { value: 'SN', label: 'Senegal' },
        { value: 'RS', label: 'Serbia' },
        { value: 'SC', label: 'Seychelles' },
        { value: 'SL', label: 'Sierra Leone' },
        { value: 'SG', label: 'Singapore' },
        { value: 'SX', label: 'Sint Maarten (Dutch part)' },
        { value: 'SK', label: 'Slovakia' },
        { value: 'SI', label: 'Slovenia' },
        { value: 'SB', label: 'Solomon Islands' },
        { value: 'SO', label: 'Somalia' },
        { value: 'ZA', label: 'South Africa' },
        { value: 'GS', label: 'South Georgia and the South Sandwich Islands' },
        { value: 'KR', label: 'South Korea' },
        { value: 'SS', label: 'South Sudan' },
        { value: 'ES', label: 'Spain' },
        { value: 'LK', label: 'Sri Lanka' },
        { value: 'SD', label: 'Sudan' },
        { value: 'SR', label: 'Suriname' },
        { value: 'SJ', label: 'Svalbard and Jan Mayen' },
        { value: 'SZ', label: 'Swaziland' },
        { value: 'SE', label: 'Sweden' },
        { value: 'CH', label: 'Switzerland' },
        { value: 'SY', label: 'Syria' },
        { value: 'TW', label: 'Taiwan' },
        { value: 'TJ', label: 'Tajikistan' },
        { value: 'TZ', label: 'Tanzania' },
        { value: 'TH', label: 'Thailand' },
        { value: 'TL', label: 'Timor-Leste' },
        { value: 'TG', label: 'Togo' },
        { value: 'TK', label: 'Tokelau' },
        { value: 'TO', label: 'Tonga' },
        { value: 'TT', label: 'Trinidad and Tobago' },
        { value: 'TN', label: 'Tunisia' },
        { value: 'TR', label: 'Turkey' },
        { value: 'TM', label: 'Turkmenistan' },
        { value: 'TC', label: 'Turks and Caicos Islands' },
        { value: 'TV', label: 'Tuvalu' },
        { value: 'UG', label: 'Uganda' },
        { value: 'UA', label: 'Ukraine' },
        { value: 'AE', label: 'United Arab Emirates' },
        { value: 'GB', label: 'United Kingdom (UK)' },
        { value: 'US', label: 'United States (US)' },
        { value: 'UY', label: 'Uruguay' },
        { value: 'UZ', label: 'Uzbekistan' },
        { value: 'VU', label: 'Vanuatu' },
        { value: 'VA', label: 'Vatican' },
        { value: 'VE', label: 'Venezuela' },
        { value: 'VN', label: 'Vietnam' },
        { value: 'WF', label: 'Wallis and Futuna' },
        { value: 'EH', label: 'Western Sahara' },
        { value: 'YE', label: 'Yemen' },
        { value: 'ZM', label: 'Zambia' },
        { value: 'ZW', label: 'Zimbabwe' },
    ];

    const handleRecaptchaVerify = (token) => {
        setGoogleCaptchaToken(token);
    };
    //const validate = () => {
    //    const newErrors = {};
    //    if (!formValues.name) newErrors.name = "Please enter your name.";
    //    if (!formValues.phone || !/^\d{10,}$/.test(formValues.phone.replace(/\D/g, "")))
    //        newErrors.phone = "Please enter your valid phone.";
    //    if (!formValues.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formValues.email))
    //        newErrors.email = "Please enter your valid email.";
    //    if (!formValues.requestReason)
    //        newErrors.requestReason = "Please select a meeting request reason.";
    //    if (!formValues.meetingDate || formValues.meetingDate < new Date())
    //        newErrors.meetingDate = "Please enter a valid meeting date.";
    //    if (!formValues.addressLine1)
    //        newErrors.addressLine1 = "Please enter your address.";
    //    if (!formValues.city) newErrors.city = "Please enter your city.";
    //    if (!formValues.state) newErrors.state = "Please enter your state.";
    //    if (!formValues.postalCode || !/^\d{5,}$/.test(formValues.postalCode))
    //        newErrors.postalCode = "Please enter your valid postal code.";
    //    if (!formValues.country) newErrors.country = "Please enter your country.";
    //    if (!formValues.message) newErrors.message = "Please enter your message.";
    //    return newErrors;
    //};
    const validate = () => {
        const newErrors = {};

        // Name: Required, Min 1 - Max 50, only letters, spaces, hyphens, and apostrophes
        if (!formValues.name || !/^[a-zA-Z\s'-]{1,50}$/.test(formValues.name))
            newErrors.name = "Please enter a valid name.";

        // Phone: Required, allows optional +, 7-15 digits
        if (!formValues.phone || !/^\d{10,}$/.test(formValues.phone.replace(/\D/g, "")))
            newErrors.phone = "Please enter your valid phone.";

        // Email: Required, valid format
        if (!formValues.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formValues.email))
            newErrors.email = "Please enter a valid email address.";

        // Meeting Request Reason: Required
        if (!formValues.requestReason)
            newErrors.requestReason = "Please select a meeting request reason.";

        // Meeting Date: Required, must be today or future
        const today = new Date().setHours(0, 0, 0, 0);
        const selectedDate = new Date(formValues.meetingDate).setHours(0, 0, 0, 0);
        if (!formValues.meetingDate || selectedDate < today)
            newErrors.meetingDate = "Please enter a valid meeting date.";

        // Address Line 1: Required, Min 5 characters
        if (!formValues.addressLine1 || formValues.addressLine1.length < 5)
            newErrors.addressLine1 = "Please enter a valid address.";

        // City: Required, Min 2 - Max 50, only letters and spaces
        if (!formValues.city)
            newErrors.city = "Please enter a valid city name.";

        // State: Required, Min 2 - Max 50, only letters and spaces
        if (!formValues.state || !/^[a-zA-Z\s]{2,50}$/.test(formValues.state))
            newErrors.state = "Please enter a valid state name.";

        // Postal Code: Required, 4-10 alphanumeric characters
        if (!formValues.postalCode || !/^[A-Za-z0-9 -]{4,10}$/.test(formValues.postalCode))
            newErrors.postalCode = "Please enter a valid postal code.";

        // Country: Required
        if (!formValues.country)
            newErrors.country = "Please select your country.";
        if (!formValues.message)
            newErrors.message = "Please enter your message.";
        // Message: Optional, but limit to 500 characters
        if (formValues.message && formValues.message.length > 500)
            newErrors.message = "Message cannot exceed 500 characters.";

        return newErrors;
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        // Perform form validation
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
        } else {
            setSubmitLoader(true);
            setErrors({});
            const formData = { ...formValues, googleCaptchaToken };

            try {
                setLoading(true);
                const result = await PostDataAPI("meetingrequest/add", formData);
                if (result.success) {
                    setMessage(result.message || "Meeting request submitted successfully.");
                    setType("success");
                    setSubmitLoader(false);
                    setTimeout(() => {
                        setResultDialog(true);
                        handleReset()
                    }, 100)


                    //showMessage("Success", result.message || "Meeting request submitted successfully.", "success", 3000);
                } else {
                    setSubmitLoader(false);
                    setMessage(result.message || "Failed to submit request.");
                    setType("error");
                    setResultDialog(true);
                    // showMessage("Error", result.message || "Failed to submit meeting request.", "error", 3000);
                }
            } catch (error) {
                //if (error.name !== 'AbortError') {
                setSubmitLoader(false);
                setMessage("Failed to submit meeting request.");
                setType("error");
                setResultDialog(true);
                //showMessage("Failed to submit meeting request.", "error", 3000);
                //}
            } finally {
                setLoading(false);
                setSubmitLoader(false);
                setRefreshCaptcha((prev) => !prev); // Trigger a refresh
            }
        }
    };
    const [submitLoader, setSubmitLoader] = useState(false);
    const [message, setMessage] = useState(null);
    const [type, setType] = useState(null);

    useEffect(() => {
        SEOTags(
            "Request a Meeting | Freddie Figgers",
            "Request a meeting with Freddie Figgers to discuss innovation, technology solutions, and impactful initiatives. Submit your details and connect directly.",
            "Request a Meeting, Freddie Figgers"
        );
    }, [])

    return (
        <>
            <Header />

            <Box
                component="form"
                className="form_container"
                onSubmit={handleSubmit}
                sx={{ maxWidth: 900, mx: "auto", p: 3, boxShadow: 3, borderRadius: 2 }}
            >
                <h2 className="page_heading">Request a Meeting</h2>

                <Grid row style={{ marginBottom: '26px' }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} lg={4}>
                            <InputLabel>Name</InputLabel>
                            <TextField
                                fullWidth
                                placeholder="Name"
                                name="name"
                                value={formValues.name}
                                onChange={handleChange}
                                error={Boolean(errors.name)}
                                helperText={errors.name}
                                inputProps={{ maxLength: 40 }}
                            />
                        </Grid>
                        <Grid item xs={12} lg={4}>
                            <InputLabel>Phone</InputLabel>
                            <TextField
                                fullWidth
                                placeholder="Phone"
                                name="phone"
                                value={formValues.phone}
                                onChange={handleChange}
                                error={Boolean(errors.phone)}
                                helperText={errors.phone}
                            />
                        </Grid>
                        <Grid item xs={12} lg={4}>
                            <InputLabel>Email</InputLabel>
                            <TextField
                                fullWidth
                                placeholder="Email"
                                name="email"
                                value={formValues.email}
                                onChange={handleChange}
                                error={Boolean(errors.email)}
                                helperText={errors.email}
                                inputProps={{ maxLength: 40 }}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid row style={{ marginBottom: '26px' }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} lg={6}>
                            <InputLabel>Meeting Request for</InputLabel>
                            <FormControl fullWidth error={Boolean(errors.requestReason)}>
                                <Select
                                    name="requestReason"
                                    value={formValues.requestReason || ''}
                                    onChange={handleChange}
                                    displayEmpty
                                >
                                    <MenuItem value="" disabled>
                                        Select Meeting Purpose
                                    </MenuItem>
                                    {meetingReasonOptions.map((option) => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                                {errors.requestReason && <FormHelperText>{errors.requestReason}</FormHelperText>}
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                            <InputLabel>Meeting Date</InputLabel>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    value={formValues.meetingDate}
                                    onChange={handleDateChange}
                                    minDate={dayjs()}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            fullWidth
                                            error={Boolean(errors.meetingDate)}
                                            helperText={errors.meetingDate}
                                            placeholder="Meeting Date"
                                        />
                                    )}
                                />
                                {errors.meetingDate && <FormHelperText style={{color:'red'} }>{errors.meetingDate}</FormHelperText>}
                            </LocalizationProvider>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid row style={{ marginBottom: '26px' }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} lg={6}>
                            <InputLabel>Address Line 1</InputLabel>
                            <TextField
                                fullWidth
                                placeholder="Address Line 1"
                                name="addressLine1"
                                value={formValues.addressLine1}
                                onChange={handleChange}
                                error={Boolean(errors.addressLine1)}
                                helperText={errors.addressLine1}
                                inputProps={{ maxLength: 100 }}
                            />
                        </Grid>
                        <Grid item xs={12} lg={6}>
                            <InputLabel>Address Line 2</InputLabel>
                            <TextField
                                fullWidth
                                placeholder="Address Line 2"
                                name="addressLine2"
                                value={formValues.addressLine2}
                                onChange={handleChange}
                                inputProps={{ maxLength: 100 }}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid row style={{ marginBottom: '26px' }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} lg={6}>
                            <InputLabel>City</InputLabel>
                            <TextField
                                fullWidth
                                placeholder="City"
                                name="city"
                                value={formValues.city}
                                onChange={handleChange}
                                error={Boolean(errors.city)}
                                helperText={errors.city}
                                inputProps={{ maxLength: 50 }}
                            />
                        </Grid>
                        <Grid item xs={12} lg={6}>
                            <InputLabel>State</InputLabel>
                            <TextField
                                fullWidth
                                placeholder="State"
                                name="state"
                                value={formValues.state}
                                onChange={handleChange}
                                error={Boolean(errors.state)}
                                helperText={errors.state}
                                inputProps={{ maxLength: 50 }}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid row style={{ marginBottom: '26px' }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} lg={6}>
                            <InputLabel>Postal Code</InputLabel>
                            <TextField
                                fullWidth
                                placeholder="Postal Code"
                                name="postalCode"
                                value={formValues.postalCode}
                                onChange={handleChange}
                                error={Boolean(errors.postalCode)}
                                helperText={errors.postalCode}
                                inputProps={{ maxLength: 10 }}
                            />
                        </Grid>
                        <Grid item xs={12} lg={6}>
                            <InputLabel>Country</InputLabel>
                            <FormControl fullWidth error={Boolean(errors.country)}>
                                <Select
                                    name="country"
                                    value={formValues.country || ''}
                                    onChange={handleChange}
                                    displayEmpty
                                >
                                    <MenuItem value="" disabled>
                                        Select Country
                                    </MenuItem>
                                    {countriesOptions.map((option) => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                                {errors.country && <FormHelperText>{errors.country}</FormHelperText>}
                            </FormControl>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid row style={{ marginBottom: '26px' }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <InputLabel>Message</InputLabel>
                            <TextField
                                fullWidth
                                multiline
                                rows={2}
                                placeholder="Message"
                                name="message"
                                value={formValues.message}
                                onChange={handleChange}
                                error={Boolean(errors.message)}
                                helperText={errors.message}
                                inputProps={{ maxLength: 500 }}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <GoogleCaptchaV3 action="MeetingRequest" onVerify={handleRecaptchaVerify} refreshTrigger={refreshCaptcha} />

                <Box mt={3} style={{ textAlign: 'right' }}>
                    <Button onClick={handleSubmit} className="request_meeting_btn" variant="contained" color="primary" type="submit" fullWidth>
                        {submitLoader ? <FontAwesomeIcon
                            icon={faSpinner}
                            className="spinner-icon"
                            spin
                            style={{ fontSize: "20px", color: "white", marginRight: "10px" }}
                        /> : ''} Request a meeting
                    </Button>
                </Box>
            </Box>
            <Footer />

            {resultDialog ?
                <SuccessErrorDialog type={type} message={message} open={resultDialog} handleClose={() => setResultDialog(false)} /> : null
            }

        </>
    );
};

export default withSnackbar(MeetingRequestForm);
